import React from 'react'
import { Link } from 'react-router-dom'

import { Box, IconButton, Container, Grid, Typography, Link as MuiLink } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import logo from '../../assets/img/kin-logo-blanco.png'
import santaLogo from '../../assets/img/kin-santa-logo.png'
import giftxchangeLogo from '../../assets/img/kin-giftxchange-logo.png'
import oraleTaqueroLogo from '../../assets/img/kin-fantabulousfredd-logo.png'

import navItems from '../../routes/pages'
import socials from '../../config/socials'

const projectLogos = {
    santasmailbox: { src: santaLogo, alt: 'KIN Navideño' },
    giftxchange: { src: giftxchangeLogo, alt: 'KIN Intercambio de regalos' },
    fantabulousfredd: { src: oraleTaqueroLogo, alt: 'KIN Solution Systems' }
}

const Footer = (props) => {
    const theme = useTheme()
    const projectLogo = projectLogos[theme.project?.id]

    return (
        <Box component="footer" sx={{ py: 3, px: 2, mt: 'auto', color: 'text.primary',
            backgroundColor: (theme) => theme.project ? theme.palette.background.paper : theme.palette.primary.main }}>
            <Container maxWidth="md">
                <Grid container rowSpacing={2} columnSpacing={5}>
                    <Grid item xs={12} sm={4} sx={{ display: 'flex', flexDirection: 'column' }} align='center'>
                        <Typography variant="h6" color="text.primary" gutterBottom align='center'>
                            Información
                        </Typography>

                        { navItems.map(item => 
                            <MuiLink key={item.label} component={Link} to={item.path}
                                color='text.secondary' underline='hover'>

                                {item.label}
                            </MuiLink>
                        )}
                    </Grid>
                    
                    <Grid item xs={12} sm={4} sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <Typography variant="body2" color="text.secondary" align="center" {...props} mb={2}>
                            <Box component="img" src={projectLogo?.src || logo} width={128}
                                alt={projectLogo?.alt || 'Kin Solution Systems Logo'}
                                sx={{ filter: projectLogo ? 'none' : (theme.project?.logoFilter || 'none') }} />
                        </Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={4}>
                        <Typography variant="h6" color="text.primary" gutterBottom>
                            Legal
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            123 Main Street, Anytown, USA
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Email: info@example.com
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Phone: +1 234 567 8901
                        </Typography>
                    </Grid> */}

                    <Grid item xs={12} sm={4} align='center'>
                        <Typography variant="h6" color="text.primary" gutterBottom align='center'>
                            Contacto
                        </Typography>

                        { socials.map(item => 
                            <IconButton key={item.url} component={Link} to={item.url} color="inherit">
                                {item.icon}
                            </IconButton>
                        ) }
                    </Grid>
                </Grid>

                <Box mt={2}>
                    <Typography variant="body2" color="text.secondary" align="center" {...props}>
                        {'Copyright © '}
                        <MuiLink component={Link} color="inherit" to="/" underline='hover'>

                            KIN Solution Systems
                        </MuiLink>{' '}
                        {new Date().getFullYear()}
                        {'.'}
                    </Typography>
                </Box>
            </Container>
        </Box>
    )
}

export default Footer
